import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { HiX } from 'react-icons/hi';
import TextInput from '@components/forms/TextInput';
import TextArea from '@components/forms/TextArea';
import { useCourses } from '@contexts/CourseContext';
import AlertBox from '../../../components/ui/AlertBox';
import { toast } from 'sonner';
import DepartmentMultiSelectInput from '@components/forms/DepartmentMultiselectInput';
import Button from '../../../components/ui/Button';
import LevelSelectInput from '../../../components/forms/LevelSelectInput';

const CourseModal = ({ isOpen, onClose, currentCourse }) => {
  const { addCourse, editCourse } = useCourses();
  const { register, handleSubmit, reset, setError, control, formState: { errors, isSubmitting } } = useForm();
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    if (currentCourse) {
      
      reset({...currentCourse, 'department_ids': currentCourse?.departments.map(department => department.id)
      })
    } else {
      reset({ code: '', title: '', description: '', departments: [] });
    }
  }, [currentCourse, reset]);

  const onSubmit = async (data) => {
    try {
      if (currentCourse) {
        await editCourse(currentCourse.id, data);
        toast.success('Course updated successfully');
      } else {
        await addCourse(data);
        toast.success('Course added successfully');
      }
      onClose();
    } catch (error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        Object.keys(errorData).forEach((field) => {
          setError(field, { type: 'server', message: errorData[field][0] });
        })
      } else {
        setSubmitError('Something went wrong. Please try again.');
      }
    }
  };

  return (
    <div className={`modal ${isOpen ? 'modal-open' : ''}`}>
      <div className="modal-box">
        <label className="absolute right-4 top-4">
          <HiX className="h-6 w-6 cursor-pointer" onClick={onClose} />
        </label>
        <h3 className="font-semibold text-lg mb-4">{currentCourse ? "Edit Course" : "Add New Course"}</h3>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          {submitError && <AlertBox message={submitError} type="error" />  }
          <TextInput
            label="Course Code"
            name="code"
            type="text"
            placeholder="e.g., CS101"
            register={register}
            errors={errors}
            validationRules={{ required: 'Course code is required' }}
          />
          <TextInput
            label="Course Title"
            name="title"
            type="text"
            placeholder="Enter course title"
            register={register}
            errors={errors}
            validationRules={{ required: 'Course title is required' }}
          />
          <TextArea
            label="Description"
            name="description"
            placeholder="Enter course description"
            register={register}
            errors={errors}
            validationRules={{ required: 'Course description is required' }}
          />
          <DepartmentMultiSelectInput
            name={"department_ids"}
            control={control}
            errors={errors}
          />

          <LevelSelectInput
            name={"level"}
            errors={errors}
            register={register}
          />
          <div className="modal-action">
            <Button isLoading={isSubmitting}>
              {currentCourse ? "Update" : "Create"} Course
            </Button>
            <button type="button" className="btn btn-ghost" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
      <div className="modal-backdrop" onClick={onClose}>
        <button className="">Close</button>
      </div>
    </div>
  );
};

export default CourseModal;
